"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _Copyable2 = _interopRequireDefault(require("./Copyable"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var WireObject = /*#__PURE__*/function (_Copyable) {
  (0, _inherits2["default"])(WireObject, _Copyable);

  var _super = _createSuper(WireObject);

  function WireObject() {
    (0, _classCallCheck2["default"])(this, WireObject);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(WireObject, [{
    key: "toJSON",
    value: function toJSON() {
      throw new Error('Sub-class of WireObject must implement toJSON method.');
    }
  }], [{
    key: "fromJSON",
    value: function fromJSON(inJSON) {
      // eslint-disable-line no-unused-vars
      throw new Error('WireObject does not directly implement static fromJSON method.');
    }
  }, {
    key: "isWireObject",
    value: function isWireObject(incoming) {
      return incoming instanceof WireObject;
    }
  }]);
  return WireObject;
}(_Copyable2["default"]);

exports["default"] = WireObject;